class StationCodeModel {
	constructor(commCode) {
		const { stnCd, stnName } = commCode;

		this.label = stnCd + '	' + stnName;
		this.value = stnCd;
	}
}

export default StationCodeModel;
